import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#collezioni", label: "Collezioni", testid: "nav-link-collezioni" },
  { href: "#configura", label: "Personalizza", testid: "nav-link-personalizza" },
  { href: "#manifesto", label: "La nostra filosofia", testid: "nav-link-manifesto" },
  { href: "#instagram", label: "Instagram", testid: "nav-link-instagram" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,border-color] duration-500 ${
        scrolled
          ? "bg-[#FDF8F7]/85 backdrop-blur-xl border-b border-[#F2DBD8] shadow-[0_1px_20px_rgba(28,25,23,0.06)]"
          : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center" data-testid="nav-logo">
          <img src="/logo.png" alt="Ma.Vi Gioielli" className="h-14 w-auto" />
        </a>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-xs uppercase tracking-[0.22em] font-medium text-[#6B5459] hover:text-[#37282B] transition-colors duration-300 relative after:absolute after:bottom-[-4px] after:left-0 after:h-px after:w-0 after:bg-[#E2A3B1] after:transition-[width] after:duration-300 hover:after:w-full"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#configura"
            data-testid="nav-cta-ordina"
            className="px-6 py-2.5 bg-[#37282B] text-[#FDF8F7] text-xs uppercase tracking-[0.2em] font-semibold rounded-full hover:bg-[#E2A3B1] hover:text-[#37282B] transition-colors duration-300"
          >
            Crea il tuo Gioiello
          </a>
        </div>

        <button
          className="md:hidden text-[#37282B]"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-[#FDF8F7] border-b border-[#F2DBD8] px-6 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`${l.testid}-mobile`}
              className="text-sm uppercase tracking-[0.2em] font-medium text-[#6B5459]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#configura"
            onClick={() => setOpen(false)}
            data-testid="nav-cta-ordina-mobile"
            className="mt-2 px-6 py-3 bg-[#37282B] text-[#FDF8F7] text-xs uppercase tracking-[0.2em] font-semibold rounded-full text-center"
          >
            Crea il tuo Gioiello
          </a>
        </div>
      )}
    </motion.header>
  );
}
